export const round = (num, decimals = 3) => Number(num.toFixed(decimals));
/** UCUM units arrive as `[IU]`/`mg/mL`; the registry keys omit brackets, dots and spaces. */
export function sanitizeUnit(unit) {
    return unit.replace(/[\s.[\]]/g, '');
}
// The single unit registry: mass units convert through mg, activity units through IU.
// IU measures biological activity, so activity and mass never convert into each other.
const UNITS = {
    g: { dimension: 'mass', factor: 1000 },
    mg: { dimension: 'mass', factor: 1 },
    microg: { dimension: 'mass', factor: 0.001 },
    ug: { dimension: 'mass', factor: 0.001 },
    µg: { dimension: 'mass', factor: 0.001 },
    IU: { dimension: 'activity', factor: 1 },
    '10*6IU': { dimension: 'activity', factor: 1_000_000 },
};
function resolveUnit(unit, role) {
    const resolved = UNITS[sanitizeUnit(unit)];
    if (resolved)
        return resolved;
    throw new Error(role === 'source' ? `Unsupported source unit: ${unit}` : `Unsupported target unit: ${unit}`);
}
export function getUnitDimension(unit) {
    return UNITS[sanitizeUnit(unit)]?.dimension ?? null;
}
export function isMassUnit(unit) {
    return getUnitDimension(unit) === 'mass';
}
export function isActivityUnit(unit) {
    return getUnitDimension(unit) === 'activity';
}
/** Shared unit scale used by both the dose and the amount converters. */
export function getUnitConversionFactor(from, to) {
    const fromUnit = resolveUnit(from, 'source');
    const toUnit = resolveUnit(to, 'target');
    if (fromUnit.dimension !== toUnit.dimension)
        throw new Error(`Cannot convert ${from} to ${to}: International Units measure biological activity and need a product-specific factor.`);
    return fromUnit.factor / toUnit.factor;
}
export function convertDose({ dose, from, to }) {
    return dose * getUnitConversionFactor(from, to);
}
export function calculateVolumeMl(dose, concentration) {
    return dose / concentration;
}
export function calculateWeightGrams(volumeMl, densityGcm3) {
    return volumeMl * densityGcm3;
}
//# sourceMappingURL=calculations.js.map